export const rootSx = {
  width: '100%',
  height: '100%',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  bgcolor: '#FFFFFF',
  borderLeft: '1px solid #E0E0E0',
  borderRight: '1px solid #E0E0E0'
};

export const headerSx = {
  minHeight: 44,
  height: 44,
  flexShrink: 0,
  px: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  bgcolor: '#FAFAFA',
  borderBottom: '1px solid #E0E0E0'
};

export const headerTitleSx = {
  fontSize: 13,
  fontWeight: 500,
  color: '#424242'
};

export const orderHxLinkSx = {
  fontSize: 13,
  fontWeight: 500,
  color: '#212121',
  textDecoration: 'underline',
  cursor: 'pointer'
};

export const expandButtonSx = {
  width: 28,
  height: 28,
  p: 0.25,
  color: '#424242',

  '&:hover': {
    bgcolor: '#F5F5F5',
    color: '#1976D2'
  },

  '& svg': {
    width: 18,
    height: 18
  }
};

export const contentSx = {
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
  scrollbarWidth: 'none',

  '&::-webkit-scrollbar': {
    display: 'none'
  }
};

export const accordionSx = {
  m: '0 !important',
  bgcolor: '#FFFFFF',
  borderBottom: '1px solid #D5D5D5',
  boxShadow: 'none',

  '&:before': {
    display: 'none'
  },

  '&.Mui-expanded': {
    m: '0 !important'
  }
};

export const accordionSummarySx = {
  minHeight: 40,
  px: 2,
  bgcolor: '#FFFFFF',

  '&.Mui-expanded': {
    minHeight: 40
  },

  '& .MuiAccordionSummary-content': {
    my: 0,
    minWidth: 0,
    alignItems: 'center',
    justifyContent: 'space-between'
  },

  '& .MuiAccordionSummary-content.Mui-expanded': {
    my: 0
  },

  '& .MuiAccordionSummary-expandIconWrapper': {
    ml: 0.5
  }
};

export const accordionTitleSx = {
  fontSize: 13,
  fontWeight: 500,
  color: '#424242'
};

export const expandMoreIconSx = {
  fontSize: 19,
  color: '#777777'
};

export const editButtonSx = {
  width: 30,
  height: 30,
  mr: 0.5,
  color: '#757575',

  '&:hover': {
    bgcolor: '#F5F5F5',
    color: '#1976D2'
  }
};

export const editIconSx = {
  fontSize: 18
};

export const getAccordionDetailsSx = backgroundColor => ({
  p: 0,
  bgcolor: backgroundColor
});

export const getTableSx = backgroundColor => ({
  width: '100%',
  tableLayout: 'fixed',
  bgcolor: backgroundColor,

  '& .MuiTableCell-root': {
    py: 1.5,
    px: 2,
    fontSize: 13,
    fontWeight: 400,
    lineHeight: 1.4,
    color: '#424242',
    bgcolor: backgroundColor,
    borderBottom: '1px solid #DDEADF',
    wordBreak: 'break-word'
  },

  '& .MuiTableRow-root:last-of-type .MuiTableCell-root': {
    borderBottom: 0
  }
});

export const rowSx = {
  '&:hover .MuiTableCell-root': {
    backgroundColor: '#FCF8F2'
  }
};

export const modalSx = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: '#FFFFFF',
  borderRadius: 1,
  outline: 'none',
  maxWidth: 'calc(100vw - 32px)',
  maxHeight: 'calc(100vh - 32px)',
  overflow: 'hidden',
  width: 750
};

export const modalHeaderSx = {
  px: 2,
  py: 1.5,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderBottom: '1px solid #E0E0E0'
};

export const modalTitleSx = {
  fontSize: 18,
  fontWeight: 500,
  color: '#212121'
};

export const modalCloseIconSx = {
  fontSize: 20
};

export const modalContentSx = {
  maxHeight: 'calc(100vh - 120px)',
  overflowY: 'auto'
};